<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> NCM </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="ncm.id"
          >{{ ncm.id }} -
          {{ ncm.name.substring(0, 30).toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="ncm.code"
                class="text-field-uppercase"
                label="Código"
                dense
                outlined
                required
                v-mask="'9999.99.99'"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="10"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-textarea
                name="input-7-1"
                label="Descrição"
                class="text-field-uppercase"
                auto-grow
                dense
                outlined
                :value="ncm.name"
                @input="(value) => (ncm.name = value)"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/NcmRequest";

import AwesomeMask from "awesome-mask";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    loading: false,
    ncm: {
      id: "",
      code: "",
      name: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getNcm(this.$route.params.id);
      }
    },
    async getNcm(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.ncm = await API.getById(id);
      } catch (error) {
        this.ncm = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Ncm" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.ncm.name = this.ncm.name.toUpperCase();
        let data = { ...this.ncm };
        // let data = new URLSearchParams(this.ncm);
        if (this.ncm.id === "") {
          this.post(data);
        } else {
          this.update(this.ncm.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
